import React from "react";

export default function VideoTitle({ title, date }) {
  const newDate = new Date("2023-01-15T15:17:01.727Z");
  const formattedDate =
    newDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }) ?? "N/A";

  return (
    <>
      <h1 className="text-lg font-semibold tracking-tight text-slate-100">
        {title}
      </h1>
      <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
        Uploaded on {formattedDate}
      </h2>
    </>
  );
}
